import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import {Modal, Colors, Table, TableCell, TableHeader, TableLoading,
    TableExpander, TextIcon, Button, Pagination } from 'advenio-components'
import StudentReceiptDetail from '../../Containers/ReceiptValidations/StudentReceiptDetail'
import ValidatedReceiptsActions from '../../Data/Redux/ValidatedReceiptsRedux'
import BalanceActions, { Selectors as BalanceSelectors } from '../../Data/Redux/BalanceRedux'
import { gb } from '../../utils/growthbook'
import { isNil, has } from 'ramda'
import { stringContainsAnyOf } from '../../utils/Utils'

// import AdjustModal from '../../Containers/ReceiptValidations/AdjustModal'
// import UnvalidatedReceiptsActions from '../../Data/Redux/UnvalidatedReceiptsRedux'

const ReceiptId = styled.span`
  color: ${Colors.red500};
`
const TableContainer = styled.div`
  .rt-tr-group{
    .invalid-receipt-btn{
      display: none;
      margin: 0 auto;
      padding: 5px;
      font-size: 14px;
    }

    &:hover{
      .valid-receipt-text{
        display: none;
      }

      .invalid-receipt-btn{
        display: block;
      }
    }
  }
`
const InfoCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
`

const ParentName = styled.span`
  margin-left: 4px;
  color: ${Colors.gray800}
`
const Container = styled.div`
  padding: 32px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  font-size: 30px;
  font-weight: bold;
  flex-direction: row;
  align-items: center;

  span {
    margin-right: 10px;
  }
`
const ValidatedReceiptsText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const UnactivateReceiptMsg = styled.div`
  padding: 0 15px 15px;

  .footer{
    text-align: center;
    padding-top: 16px;
  }
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`

class Receipts extends Component {

    state = {
        expanded: [],
        openModal: false,
        isMexican: false,
        receiptToInvalidate: null,
        pageSelected: 1,
        queryParams: {},
    } 

    componentWillMount = () => { 
        const{getReceipts,student}=this.props;
         getReceipts(student.id,{page:1});
    }

    // componentWillReceiveProps = (nextProps) =>{
    //    if (this.props.receipts.lenght !== nextProps.receipts.lenght){
    //             nextProps.getReceipts(nextProps.student.id);
    //     }
        
    // }

    componentWillUnmount(){
        this.props.setReceipts()
    }

    toggleViewReceiptDetail = (index) => {
        const newState = { ...this.state }
        newState.expanded[index] = !newState.expanded[index]
        this.setState(newState)
    }

    onClickPage = (pageSelected) => {
        this.setState({ pageSelected }, () => {
          const queries = { page: pageSelected }
          const { getReceipts, student } = this.props
          getReceipts(student.id,queries)
        })
    }

    getButtonInvalid = (user,id) => {
      const feature = gb.getFeatureValue('users-unvalidate-receipt', null)
      let users = []
      if(!isNil(feature)){
        users = feature.users || []
      }
      
      if(user.role === 'Back Office Admin' || stringContainsAnyOf(user.id.toString(),users)){
        return (
            <Button className="invalid-receipt-btn" danger onClick={() => this.setIdReceiptToInvalidate(id)} small>
                <TextIcon flex flexCenter label="Invalidar" iconType="close" iconColor="" />
            </Button>
        );
      }
    }

    setIdReceiptToInvalidate = (id = null) => this.setState({ receiptToInvalidate: id })

    invalidateReceipt = () => {
        this.props.unvalidateReceipt(this.state.receiptToInvalidate, { force: true })
        this.setIdReceiptToInvalidate()
    }

    render() {
        const {loading,receipts,user,meta } = this.props
        const { expanded,  pageSelected} = this.state

        return (
            <Container>
                <HeaderContainer>
                <span>
                    Recibos Validados
                </span>
                {/* <RoundedTabs
                    selectedTab={'/unvalidated-receipts'}
                    tabs={[
                    {
                        id: '/unvalidated-receipts',
                        title: 'Por validar',
                    },
                    {
                        id: '/validated-receipts',
                        title: 'Validados',
                    },
                    ]}
                    onClick={this.goTo}
                /> */}
                </HeaderContainer>
                <TableContainer>
                <PaginationContainer>
                    <Pagination
                    totalElements={meta && meta.total}
                    elementsPerPage={meta && meta.per_page}
                    onPageClick={this.onClickPage}
                    pageSelected={pageSelected}
                    /> 
                </PaginationContainer>
                {loading ?
                    <TableLoading
                    roundedCorners
                    columns={[
                        {
                        id: 1,
                        header: 'Fecha de Validación',
                        element: 'Text',
                        center: true,
                        },
                        {
                        id: 2,
                        header: '# de Recibo',
                        element: 'Text',
                        center: false,
                        },
                        {
                        id: 3,
                        header: 'Tutor',
                        element: 'Text',
                        center: false,
                        },
                        {
                        id: 4,
                        header: 'Monto',
                        element: 'Text',
                        center: true,
                        },
                        {
                        id: 5,
                        header: '',
                        element: 'Text',
                        center: true,
                        },
                    ]}
                    rows={10}
                    />
                    :
                    <Table
                    roundedCorners
                    SubComponent={HOC(StudentReceiptDetail)}
                    data={receipts}
                    expanded={expanded}
                    columns={[
                        {
                        id: 1,
                        expander: true,
                        Header: () => <TableHeader blue />,
                        Expander: ({ isExpanded, ...rest }) => (
                            <TableCell>
                            <TableExpander
                                id={rest.index}
                                open={isExpanded}
                                openCard={() => this.toggleViewReceiptDetail(rest.index)}
                            />
                            </TableCell>
                        ),
                        },
                        {
                        id: 2,
                        Header: () => <TableHeader title="Fecha de Validación" blue />,
                        accessor: ({ validated_at }) => ({ validated_at }),
                        Cell: ({ value: { validated_at } }) =>
                            <TableCell>{moment(validated_at).format('YYYY-MM-DD HH:mm')}</TableCell>,
                        maxWidth: 200,
                        },
                        {
                        id: 3,
                        Header: () => <TableHeader title="# de Recibo" blue />,
                        accessor: ({ id }) => ({ id }),
                        Cell: ({ value: { id } }) => <TableCell ><ReceiptId>{id}</ReceiptId></TableCell>,
                        maxWidth: 200,
                        },
                        {
                        id: 4,
                        Header: () => <TableHeader title="Alumno" blue />,
                        accessor: ({  parent }) => ({  parent }),
                        Cell: ({ value: {  parent } }) => (
                            <TableCell >
                            <InfoCell>
                                <InfoRow>
                                Tutor: <ParentName>{parent && parent.name}</ParentName>
                                </InfoRow>
                            </InfoCell>
                            </TableCell>
                        ),
                        },
                        {
                        id: 5,
                        Header: () => <TableHeader title="Monto" blue center />,
                        accessor: ({ total_formatted }) => ({ total_formatted }),
                        Cell: ({ value: { total_formatted } }) =>
                            <TableCell center>{total_formatted}</TableCell>,
                        maxWidth: 200,
                        },
                        {
                            id: 6,
                            Header: () => <TableHeader blue />,
                            maxWidth: 200,
                            Cell: ({ original: { id } }) => (
                                <TableCell center>
                                    <ValidatedReceiptsText
                                        label="Validado"
                                        iconType="checkmark"
                                            iconViewBox="0 1 18 18"
                                        iconColor={Colors.green500}
                                        className={user.role === 'Back Office Admin'?"valid-receipt-text":null}
                                    />
                                {this.getButtonInvalid(user,id)}
                                </TableCell>
                            ),
                        },
                    ]}
                    />
                }
                </TableContainer>
                <Modal
                isOpened={this.state.receiptToInvalidate !== null}
                onClose={this.setIdReceiptToInvalidate}
                headerTitle="¿Invalidar recibo?"
                id="modal-invalidate-receipt"
                smallHeader
                >
                    <UnactivateReceiptMsg>
                        <p>¿Estas seguro de invalidar el recibo con número:
                        <strong> {this.state.receiptToInvalidate}</strong>?</p>
                        <div className="footer">
                            <Button onClick={() => this.setIdReceiptToInvalidate()} small>Cancelar</Button>
                            <Button onClick={() => this.invalidateReceipt()} primary small>Invalidar</Button>
                        </div>
                    </UnactivateReceiptMsg>
                </Modal>
            </Container>
        )
    }
    
}
Receipts.propTypes = {
    // /** The current center */
    // center: PropTypes.object,
    /** A listing of supported countries */
    // countries: PropTypes.array.isRequired,
    /** A listing of consumables that can be charged to a receipt */
    // consumables: PropTypes.array,
    /** Loading flag */
    loading: PropTypes.bool.isRequired,
    /** A listing of types of payments that can be used to pay a receipt */
    // paymentTypes: PropTypes.array,
    /** The listing of unvalidated receipts */
    receipts: PropTypes.array,
    // /** Meta data for the paginated results */
    // meta: PropTypes.oneOfType([
    //   PropTypes.func,
    //   PropTypes.object,
    // ]),
    // /** React router location information, containing query params etc. */
    // location: PropTypes.oneOfType([
    //   PropTypes.func,
    //   PropTypes.object,
    // ]),
    /** Flag marking whether a request is being sent to the API */
    // sending: PropTypes.bool,
    /** The currently authenticated user */
    user: PropTypes.object.isRequired,
  
    // /**
    //   * Submit an adjustment transaction for the given receipt.
    //   * This adjustment may be a charge or a payment.
    //   */
    // adjustTransaction: PropTypes.func.isRequired,
    // /** Fetch information for the current center */
    // getCenter: PropTypes.func.isRequired,
    // /** Fetch a listing of all classrooms in this center */
    // getClassrooms: PropTypes.func.isRequired,
    // /** Fetch a listing of all available countries */
    // getCountries: PropTypes.func.isRequired,
    // /** Fetch the listing of unvalidated receipts from the API */
    // getReceipts: PropTypes.func.isRequired,
    // /** Navigate to the given URI */
    // goTo: PropTypes.func.isRequired,
    // /** Navigate to the given student's profile */
    // sendToAccount: PropTypes.func.isRequired,
    // /** Set the ID of the student before navigating to their profile */
    // setActiveStudentId: PropTypes.func.isRequired,
    // /** Set the ID of the active classroom before navigating to a student's profile */
    // setActiveClassroomId: PropTypes.func.isRequired,
    /** Submit a request to the API to mark a given receipt as validated */
    // validateReceipt: PropTypes.func.isRequired,
    /** Submit a request to the API to mark a given receipt as unvalidated */
    unvalidateReceipt: PropTypes.func.isRequired,
}
  
Receipts.defaultProps = {
    // center: {},
    // consumables: [],
    // inscriptions: [],
    // meta: () => {},
    // location: {},
    // paymentTypes: [],
    // loading:false,
    receipts: [],
    // sending: false,
}
  
const mapStateToProps = ({  auth, balance }) => ({
    receipts: balance.receiptsValidated.results.data,
    meta: balance.receiptsValidated.results.meta,
    loading: balance.receiptsValidated.fetching,
    user: auth.user,
    // consumables: consumables.get.results,
    // countries: countries.get.results,
    // sending: balance.transaction.fetching,
    // center: centers.getOne.result,
    // paymentTypes: parent_payment_types.get.results,
})

const mapDispatchToProps = dispatch => ({
    // getReceipts: query => dispatch(UnvalidatedReceiptsActions.getRequest(query)),
    // validateReceipt: id => dispatch(UnvalidatedReceiptsActions.validateRequest(id)),
    // getCenter: centerId => dispatch(CenterActions.getOneRequest(centerId)),
    // adjustTransaction: (receiptId, data) =>
    //   dispatch(BalanceActions.adjustTransactionRequest(receiptId, data)),
    // sendToAccount: () => dispatch(UnvalidatedReceiptsActions.sendToAccount()),
    // setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
    // setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
    // getClassrooms: () => dispatch(ClassroomActions.getRequest()),
    // goTo: path => dispatch(push(path)),
    // getCountries: () => dispatch(CountriesActions.getRequest()),
    unvalidateReceipt: (id, body) => dispatch(ValidatedReceiptsActions.unvalidateRequest(id, body)),
    getReceipts: (studentId, query) => dispatch(BalanceActions.getValidatedReceiptsRequest(studentId,query)),
    setReceipts: () => dispatch(BalanceActions.setReceitps()),

  })

const HOC = (SubComponent) => {
             return class extends Component {
                render() {
                    return <SubComponent
                    {...this.props}
                    />
                }
             }
}
export default connect(mapStateToProps, mapDispatchToProps)(Receipts)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Receipts.jsx